import "./FullPageCard.css";

import { CSSProperties, ReactNode } from "react";

interface FullPageCardProps {
  children: ReactNode;
  corners?: "default" | "rounded";
  padding?: "ll";
  paddingBottom?: "4xl" | "l" | "s";
  style?: CSSProperties;
}

export const FullPageCard = ({
  children,
  corners = "default",
  padding,
  paddingBottom = "4xl",
  style,
}: FullPageCardProps): JSX.Element => {
  return (
    <div style={style} className={`FullPageCard ${corners} Padding_${padding} PaddingBottom_${paddingBottom}`}>
      {children}
    </div>
  );
};
